import React, { Fragment } from 'react';
import ContainerHeader from 'components/ContainerHeader';
import ProjectPrioritiesTable from '../projectPrioritiesTable';


const ProjectPriorities = ({ priorities, title }) => {
    if (priorities && Array.isArray(priorities) && priorities.length > 0) {
        return (
            <Fragment>
                <ContainerHeader title={title} />
                <div className="row">
                    <div className="col-md-12 col-sm-12 col-12">
                        <div className="col-sm-12 text-center text-sm-left">
                            <ProjectPrioritiesTable priorities={priorities} />
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    } else {
        return (
            <div className="row">
                <div className="col-md-12 col-12">
                    <Fragment>
                        <ContainerHeader title={title} />
                        <div className="mr-auto">
                            <h3 className="card-heading">No priorities found here</h3>
                        </div>
                    </Fragment>
                </div>
            </div>
        );
    }
};

export default ProjectPriorities;


// WEBPACK FOOTER //
// ./components/Agile/project/projectDetail/projectPriorities/index.js